import { sidebarInterface } from '../../models/sideBar.model';
import { assets } from './assets.const';

export const ModuleConst = {
  Dashboard: 1,
  Users: 2,
  Partners: 3,
  propertyListing: 4,
  Adverts: 5,
  Categories: 6,
  Loyalty: 7,
  Transactions: 8,
  Chat: 9,
  Portfolios: 10,
  CMS: 11,
  SubAdmin: 12,
  Notification: 13,
  Amenities: 14,
  Setting: 15,
  Advertment: 16,
  Report: 17
};

export const sideBar: sidebarInterface[] = [
  {
    text: 'Dashboard',
    path: '/dashboard',
    img: assets.sidebarDashboardIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Dashboard
  },
  {
    text: 'ManageUsers',
    path: '/manage-users',
    img: assets.UsersIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Users
  },

  {
    text: 'ManagePartners',
    path: '/manage-companies',
    img: assets.PropertyIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Partners
  },
  {
    text: 'ManageListing',
    path: '/manage-properties',
    img: assets.HouseIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.propertyListing
  },
  {
    text: 'ManageAdvertment',
    path: '/manage-advertisments',
    img: assets.AdvertisementIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Advertment
  },
  {
    text: 'ManageAdverts',
    path: '/manage-advertiser',
    img: assets.AdvertisementIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Adverts
  },
  {
    text: 'ManageCategories',
    path: '/manage-categories',
    img: assets.CategoryIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Categories
  },

  {
    text: 'ManageLoyalty',
    path: '/loyalty',
    img: assets.LoyaltyIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Loyalty
  },
  {
    text: 'manageAmenities',
    path: '/manage-amenities',
    img: assets.LoyaltyIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Amenities
  },
  {
    text: 'Manage Transactions',
    path: '/manage-transactions',
    img: assets.paymentIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Transactions
  },

  {
    text: 'Manage Chat',
    path: '/chat',
    img: assets.ChatIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Chat
  },
  {
    text: 'ManagePortfolios',
    path: '/portfolios',
    img: assets.PortfolioIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Portfolios
  },

  {
    text: 'ManageSubAdmin',
    path: '/subadmin',
    img: assets.SubadminIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.SubAdmin
  },
  {
    text: 'ManagePropertyReport',
    path: '/manage-report',
    img: assets.SubadminIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Report
  },

  {
    text: 'NotificationManagement',
    path: '/notification',
    img: assets.NotificationIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Notification
  },
  {
    text: 'ManageCMS',
    path: '/cms',
    img: assets.CmsIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.CMS
  },
  {
    text: ' Settings',
    path: '/settings',
    img: assets.SubadminIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Setting
  }
];
